export default __webpack_public_path__ + "static/doublo-caisse-americaine-a9f70b49387191a82ccfcf21720529ec.gif";